export const colors = {
  primary25: '#E6F6FF',
  primary50: '#D4EFFE',
  primary100: '#AAE1FF',
  primary200: '#80D2FF',
  primary300: '#004DFE',
  primary400: '#2AB3FF',
  primary500: '#1CAEFF',
  primary600: '#004DFE',
  primary700: '#01A4FE',
  primary800: '#005280',
  primary900: '#003755',
  primary950: '#001B2A',
  primary1000: '#004DFE',
  primary1050: '#01A4FE',

  secondary25: '#F5FAFF',
  secondary50: '#EFF8FF',
  secondary100: '#D1E9FF',
  secondary200: '#B2DDFF',
  secondary300: '#84CAFF',
  secondary400: '#53B1FD',
  secondary500: '#2E90FA',
  secondary600: '#1570EF',
  secondary700: '#175CD3',
  secondary800: '#1849A9',
  secondary900: '#194185',
  secondary950: '#102A56',

  black100: '#000000',
  black01: '#18181B',
  black02: '#27272A',
  black03: '#3F3F46',
  black07: '#D4D4D8',

  white25: '#E6F6FF',
  white100: '#ffffff',

  gray25: '#FCFCFD',
  gray50: '#F9FAFB',
  gray100: '#F2F4F7',
  gray200: '#EAECF0',
  gray300: '#D0D5DD',
  gray400: '#98A2B3',
  gray500: '#667085',
  gray600: '#475467',
  gray700: '#344054',
  gray800: '#1D2939',
  gray900: '#101828',
  gray950: '#0C111D',

  success25: '#F6FEF9',
  success50: '#ECFDF3',
  success100: '#DCFAE6',
  success200: '#ABEFC6',
  success300: '#75E0A7',
  success400: '#47CD89',
  success500: '#17B26A',
  success600: '#079455',
  success700: '#067647',
  success800: '#085D3A',
  success900: '#074D31',
  success950: '#053321',

  warning25: '#FFFCF5',
  warning50: '#FFFAEB',
  warning100: '#FEF0C7',
  warning200: '#FEDF89',
  warning300: '#FEC84B',
  warning400: '#FDB022',
  warning500: '#F79009',
  warning600: '#DC6803',
  warning700: '#B54708',
  warning800: '#93370D',
  warning900: '#7A2E0E',
  warning950: '#4E1D09',

  error25: '#FFFBFA',
  error50: '#FEF3F2',
  error100: '#FEE4E2',
  error200: '#FECDCA',
  error300: '#FDA29B',
  error400: '#F97066',
  error500: '#F04438',
  error600: '#D92D20',
  error700: '#B42318',
  error800: '#912018',
  error900: '#7A271A',
  error950: '#55160C',
}

export const oldColors = {
  primary25: '#FCFAFF',
  primary50: '#F9F5FF',
  primary100: '#F4EBFF',
  primary200: '#E9D7FE',
  primary300: '#D6BBFB',
  primary400: '#B692F6',
  primary500: '#9E77ED',
  primary600: '#7F56D9',
  primary700: '#6941C6',
  primary800: '#53389E',
  primary900: '#42307D',
  primary950: '#2C1C5F',

  secondary25: '#F5FAFF',
  secondary50: '#EFF8FF',
  secondary100: '#D1E9FF',
  secondary200: '#B2DDFF',
  secondary300: '#84CAFF',
  secondary400: '#53B1FD',
  secondary500: '#2E90FA',
  secondary600: '#1570EF',
  secondary700: '#175CD3',
  secondary800: '#1849A9',
  secondary900: '#194185',
  secondary950: '#102A56',

  white100: '#ffffff',
  black100: '#000000',

  gray25: '#FCFCFD',
  gray50: '#F9FAFB',
  gray100: '#F2F4F7',
  gray200: '#EAECF0',
  gray300: '#D0D5DD',
  gray400: '#98A2B3',
  gray500: '#667085',
  gray600: '#475467',
  gray700: '#344054',
  gray800: '#1D2939',
  gray900: '#101828',
  gray950: '#0C111D',

  success25: '#F6FEF9',
  success50: '#ECFDF3',
  success100: '#DCFAE6',
  success200: '#ABEFC6',
  success300: '#75E0A7',
  success400: '#47CD89',
  success500: '#17B26A',
  success600: '#079455',
  success700: '#067647',
  success800: '#085D3A',
  success900: '#074D31',
  success950: '#053321',

  warning25: '#FFFCF5',
  warning50: '#FFFAEB',
  warning100: '#FEF0C7',
  warning200: '#FEDF89',
  warning300: '#FEC84B',
  warning400: '#FDB022',
  warning500: '#F79009',
  warning600: '#DC6803',
  warning700: '#B54708',
  warning800: '#93370D',
  warning900: '#7A2E0E',
  warning950: '#4E1D09',

  error25: '#FFFBFA',
  error50: '#FEF3F2',
  error100: '#FEE4E2',
  error200: '#FECDCA',
  error300: '#FDA29B',
  error400: '#F97066',
  error500: '#F04438',
  error600: '#D92D20',
  error700: '#B42318',
  error800: '#912018',
  error900: '#7A271A',
  error950: '#55160C',
}
